var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"textual-toggle",style:('color: '+(_vm.activeState.color || 'inherit')),attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.nextState()}}},[_vm._v(_vm._s(_vm.activeState.name))])}
var staticRenderFns = []

export { render, staticRenderFns }